import type { IconType } from "react-icons";
import { images, type ImageKey } from "@core/assets";

type ImageProps = {
  /** Accepts an ImageKey, a raw URL string, or an IconType (backward compat). */
  src: ImageKey | string | IconType | undefined;
  alt?: string;
  className?: string;
  onClick?: () => void;
  onError?: () => void;
  style?: React.CSSProperties;
};

const Image = ({
  src,
  alt = "image",
  className,
  onClick,
  onError,
  style,
}: ImageProps) => {
  if (!src) return null;

  // IconType — backward compat for consumers that pass a Lucide icon component
  if (typeof src === "function") {
    const Icon = src as IconType;
    return <Icon className={className} onClick={onClick} aria-label={alt} />;
  }

  const resolved =
    typeof src === "string" && src in images
      ? images[src as ImageKey]
      : (src as string);

  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      onClick={onClick}
      onError={onError}
      loading="lazy"
      style={style}
    />
  );
};

Image.displayName = "Image";

export default Image;
